import { Injectable } from '@angular/core';
import { IDownloadable } from '@redngapps/shared/types';
import JSZip from 'jszip';
import { defer, from, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ZipService {
  /**
   * @deprecated use createZip instead
   */
  async createZipPromise(files: Array<IDownloadable>): Promise<Blob> {
    const zip = new JSZip();
    for (const file of files) {
      zip.file(file.fileName, file.content);
    }

    return await zip.generateAsync({
      type: 'blob',
      compression: 'DEFLATE',
      compressionOptions: {
        level: 4,
      },
    });
  }

  createZip(files: Array<IDownloadable>): Observable<Blob> {
    const zip = new JSZip();
    for (const file of files) {
      zip.file(file.fileName, file.content);
    }

    return defer(() =>
      zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: {
          level: 4,
        },
      }),
    );
  }

  /**
   * @deprecated no new code should work with promises
   */
  async createZipBase64Promise(files: Array<IDownloadable>): Promise<string> {
    const zip = new JSZip();
    for (const file of files) {
      zip.file(file.fileName, file.content);
    }

    return await zip.generateAsync({
      type: 'base64',
      compression: 'DEFLATE',
      compressionOptions: {
        level: 4,
      },
    });
  }

  createZipBase64(files: Array<IDownloadable>): Observable<string> {
    const zip = new JSZip();
    for (const file of files) {
      zip.file(file.fileName, file.content);
    }

    return from(
      zip.generateAsync({
        type: 'base64',
        compression: 'DEFLATE',
        compressionOptions: {
          level: 4,
        },
      }),
    );
  }

  createZipBlob(files: Array<IDownloadable>): Observable<Blob> {
    const zip = new JSZip();
    for (const file of files) {
      zip.file(file.fileName, file.content, { base64: true });
    }

    return from(
      zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: {
          level: 4,
        },
      }),
    );
  }

  downloadZipFile(file: Blob, fileName: string): Observable<boolean> {
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(file);
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.click();
    return of(true);
  }
}
